import { COLORS } from 'helpers/globals'

export default {
  dialog: {
    width: '90%',
    maxWidth: '400px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    background: 'white'
  },
  header: {
    background: COLORS.primary,
    color: 'white',
    fontWeight: '500',
    fontSize: '2rem',
    textAlign: 'center'
  },
  body: {
    padding: '.5rem'
  },
  result: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem'
  },
  failIcon: {
    color: 'red',
    marginRight: '1rem',
    fontSize: '3rem'
  },
  text: {
    marginTop: '1rem',
    marginBottom: '0rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileStart/MobileError/style.js